<template lang="pug">
  .gl-forgot-password.gl-layout--medium-width

    // logo
    .gl-card--logo-above
      img(v-gl-wl="{ insert: 'loginLogo' }")

    // loading: config
    gl-loading-card(:options="{ message: 'Loading application', location: 'page' }" v-if="!config")

    // form
    b-form.gl-card.gl-card--form(@submit.prevent="submitForm" v-if="config" novalidate)

      // header
      .gl-card--form__header
        .gl-card--form__header__title Forgot your password?

      // body
      .gl-card--form__body
        gl-alert(
          :options="{ errorList, infoList }"
          @clear-error-list="errorList = []"
          @clear-info-list="infoList = []")
        b-form-group(:state="form.email.state" v-gl-wl="{ apply: [ 'formLabelColor', 'formLabelFontWeight' ] }" label="Email Address" label-for="email")
          b-form-input(
            :state="form.email.state"
            v-model.trim="form.email.val"
            v-gl-focus="true"
            required
            type="text")
          .invalid-feedback(v-if="form.email.invalidFeedback") {{ form.email.invalidFeedback }}

      // footer
      .gl-card--form__footer
        gl-btn(:options="{ label: 'Email Reset Instructions', size: 'full-width', type: 'submit', style: 'brand', isLoading: isLoading.submitForm }")
        router-link.gl-card--form__footer__link(:to="{ name: 'login' }" v-gl-wl="{ apply: 'linkColor' }") Back to Sign in
</template>

<script>
import { mapGetters } from 'vuex'

export default {

  // computed
  computed: {
    ...mapGetters(['config'])
  },

  // data
  data () {
    return {
      errorList: [],
      infoList: [],
      form: {
        email: { val: '', state: null, invalidFeedback: '' }
      },
      isLoading: {
        submitForm: false
      }
    }
  },

  // methods
  methods: {
    submitForm () {
      // clear previous lists
      this.infoList = []
      this.errorList = []

      // clear previous feedback
      this.$glForm.clearFeedback(this.form)

      // if form is valid
      if (this.validateForm()) {
        // start loading
        this.isLoading.submitForm = true

        // requestPasswordReset
        return this.$glHttp.post('user/forgot-password', { email: this.form.email.val })
          .then(() => {
            // push info
            this.infoList.push('Email sent to ' + this.form.email.val)
          })
          .catch(e => {
            // push server error
            this.errorList.push(this.$glForm.parseError(e))
          })
          .finally(() => {
            // stop loading
            this.isLoading.submitForm = false
          })
      } else {
        // focus first error
        this.$glForm.focusFirstError({ el: this.$el })
      }
    },
    validateForm () {
      // if no email -> invalid
      if (!this.form.email.val) {
        this.form.email.state = 'invalid'
        this.form.email.invalidFeedback = 'An email address is required'
      }
      // if email does not have an @ -> invalid
      if (this.form.email.val && !this.form.email.val.match(/\S+@\S+/)) {
        this.form.email.state = 'invalid'
        this.form.email.invalidFeedback = 'A valid email address is required'
      }

      // return true if no fields are invalid
      return this.$glForm.hasNoInvalid(this.form)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/ForgotPassword.vue